import DocumentInstanceInList from './DocumentInstanceInList.component';

export default DocumentInstanceInList;
